var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',_vm._g(_vm._b({attrs:{"title":_vm.headerTitle}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("title",null,{"slot":"title"}),_vm._t("default"),_vm._t("footer",null,{"slot":"footer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }